import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.myMirabToken;
axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
  sendCode({ dispatch, commit }, data) {
    commit("setCheckCode", false);
    commit("setLoginCheck", true);
    axios
      .post("Account/ValidateUser", data)
      .then((res) => {
        if (res.data && res.data.status === 200) {
          commit("setCheckCode", res.data);
          commit("setSuccess", res.data.message, { root: true });
        } else {
          commit("setError", res.data.message, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  login({ dispatch, commit, state }, data) {
    commit("setLoginCheck", true);
    axios
      .post("Account/SMSValidation", data)
      .then((res) => {
        if (res.data && res.data.status === 200) {
          commit("authUser", res.data.data);
          localStorage.setItem("myMirabToken", res.data.data.accessToken);
          localStorage.setItem("myMirabUser", res.data.data.userId);
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + res.data.data.accessToken;
          // set RegToken for notification handler
          const payload = {
            token: state.deviceRegistrationToken,
            platform: 2,
          };
          dispatch("addRegToken", payload, { root: true });
          router.push({ name: "Dashboard" });
          setTimeout(() => {
            commit("setSuccess", alert.success.login, { root: true });
          }, 800);
        } else {
          commit("setError", res.data.message, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  addRegToken({ commit }, data) {
    axios
      .post(
        "Account/AddOrEditRegToken?regToken=" +
          data.token +
          "&platform=" +
          data.platform
      )
      .then((res) => {
        if (res.data && res.data.status === 200) {
          console.log(res.data.message);
        } else {
          console.log(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response.data.message);
        commit("setError", error.response.data.message, { root: true });
      });
  },

  getRequestsCount({ dispatch, commit }) {
    axios
      .get("Kara/RequestCount")
      .then((res) => {
        commit("setRequestsCount", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  logout({ commit }) {
    localStorage.removeItem("myMirabToken");
    axios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    router.push({ name: "Login" });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server.data && data.server.data.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
      commit("setPostCheck", false, { root: true });
    }
  },

  successPOSTHandlerSimple({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response.data &&
      data.response.data.message &&
      data.response.data.message !== ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    } else if (data.response.data && data.response.data.title !== "") {
      commit("setError", data.response.data.title, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },
};
